export default "__VITE_ASSET__BSPAxPHT__"